function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#3E3E3E",
  d: "M44,50H6c-3.314,0-6-2.686-6-6V4h50v40C50,47.314,47.314,50,44,50z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 34,
  fill: "#804998",
  width: 23,
  height: 12
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  fill: "#804998",
  width: 7,
  height: 12
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 7,
  height: 2
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 4,
  fill: "#E5E5E5",
  width: 11,
  height: 12
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 4,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 11,
  height: 2
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 4,
  fill: "#804998",
  width: 4,
  height: 12
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 4,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 4,
  height: 2
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 4,
  fill: "#59B4D9",
  width: 11,
  height: 12
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 4,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 11,
  height: 2
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 34,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 23,
  height: 2
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 34,
  fill: "#59B4D9",
  width: 16,
  height: 12
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 34,
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 16,
  height: 2
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 19,
  fill: "#E5E5E5",
  width: 23,
  height: 12
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  y: 19,
  transform: "matrix(-1 -4.484203e-11 4.484203e-11 -1 69 40)",
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 23,
  height: 2
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 19,
  fill: "#59B4D9",
  width: 16,
  height: 12
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 19,
  transform: "matrix(-1 -4.502011e-11 4.502011e-11 -1 24 40)",
  opacity: 0.2,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  width: 16,
  height: 2
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fill: "#FFFFFF",
  enableBackground: "new    ",
  d: "M6,50h2.696L40.081,4H0v40C0,47.314,2.686,50,6,50z"
});

const SvgAzureBlob = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  width: "50px",
  height: "50px",
  viewBox: "0 0 50 50",
  enableBackground: "new 0 0 50 50",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAzureBlob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/azure_blob.c2112ade.svg";
export { ForwardRef as ReactComponent };